// AUTO-GENEROWANE przy starcie/buildzie (scripts/gen-build-info.js). Nie edytuj ręcznie.
export const BUILD_INFO = {"version":"1.9.22","builtAt":"2026-11-04T16:30:50.090Z"};
